import { useContext, useState } from 'react';
import Container from 'react-bootstrap/Container';
import './styles.scss';
import { ThemeContext } from '../../../context/theme-context';
import ListaFormaRecebimento from '../../../Components/Financeiro/FormaRecebimento/ListaFormaRecebimento';

export default function CadFormaRecebimento() {
  const { collapsed } = useContext(ThemeContext);
  const [menuSelected, setMenuSelected] = useState<string>("");

  return (
    <>
      <Container
        className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
      >
        <ListaFormaRecebimento
          Title="Forma "
          keyTab="revenue"
          Path=""
          menuSelected={menuSelected}
          setMenuSelected={setMenuSelected}
        />
      </Container>
    </>
  );
}
